import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { CompaniaComponent } from './compania/compania.component';
import { VehiculoComponent } from './vehiculo/vehiculo.component';
import { UsuarioComponent } from './usuario/usuario.component';
import { ZonaComponent } from './zona/zona.component';
import { RutaComponent } from './ruta/ruta.component';
import { PuntoVisitaComponent } from './punto-visita/punto-visita.component'
import { VisitaComponent } from './visita/visita.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { SeguridadLayoutComponent } from './seguridad-layout/seguridad-layout.component';
import { LoginComponent } from './login/login.component';
import { IncioComponent } from './incio/incio.component';
import { patch } from 'webdriver-js-extender';

import { CalendarioComponent } from './calendario/calendario.component';

import { ReporteviajeComponent } from './reporteviaje/reporteviaje.component'
import { ReportePuntoVisitaComponent } from './reporte-punto-visita/reporte-punto-visita.component'
import { ActualizarPuntoVisitaComponent } from './actualizar-punto-visita/actualizar-punto-visita.component'



import { ReporteCertificacionClienteComponent }  from './reporte-certificacion-cliente/reporte-certificacion-cliente.component'


import { CorreoClienteLayoutComponent } from './correo-cliente-layout/correo-cliente-layout.component'
import { ReporteErrorComponent } from './reporte-error/reporte-error.component';
import { ReporteFacturacionComponent } from './reporte-facturacion/reporte-facturacion.component';
import { CerrarViajeForzadoComponent } from './cerrar-viaje-forzado/cerrar-viaje-forzado.component';

import { ReporteGaleriaComponent } from './reporte-galeria/reporte-galeria.component';
import { ReglasComponent } from './reglas/reglas.component';

import { ReporteViajeContenedorComponent } from './reporte-viaje-contenedor/reporte-viaje-contenedor.component';
import { ReportePuntoVisitaDistanciaComponent } from './reporte-punto-visita-distancia/reporte-punto-visita-distancia.component';

import { ReportePagoComponent } from './reporte-pago/reporte-pago.component';

import { ReporteViajeReciboConformeComponent } from './reporte-viaje-recibo-conforme/reporte-viaje-recibo-conforme.component';
import { MedicionComponent } from './medicion/medicion.component';
import { ReportePagosEfectuadosComponent } from './reporte-pagos-efectuados/reporte-pagos-efectuados.component';
import { ReporteDevolucionesComponent } from './reporte-devoluciones/reporte-devoluciones.component';
import { ReporteMedicionVehiculoComponent } from './reporte-medicion-vehiculo/reporte-medicion-vehiculo.component';
import { MotivoComponent } from './motivo/motivo.component';
import { CorreoComponent } from './correo/correo.component';
import { TrasladoMercaderiaComponent } from './traslado-mercaderia/traslado-mercaderia.component';
import { ImportarExcelComponent } from './importar-excel/importar-excel.component';
import { ReporteDevolucionLibreComponent } from './reporte-devolucion-libre/reporte-devolucion-libre.component';

//indicadores
import { IndicadorVisitaClienteComponent } from './indicador-visita-cliente/indicador-visita-cliente.component';
import { IndicadorEntregaChoferComponent } from './indicador-entrega-chofer/indicador-entrega-chofer.component';
import { IndicadorFacturasChoferComponent } from './indicador-facturas-chofer/indicador-facturas-chofer.component';
import { IndicadorProporcionEntregaComponent } from './indicador-proporcion-entrega/indicador-proporcion-entrega.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '', component: SeguridadLayoutComponent,
    children: [

      { path: 'login', component: LoginComponent }

    ],
  },
  { path: '', redirectTo: '/reporte-certificacion', pathMatch: 'full' },
  {
    path: '', component: CorreoClienteLayoutComponent,
    children: [

      { path: 'reporte-certificacion/:compania/:idviaje/:idvisita', component: ReporteCertificacionClienteComponent }

    ],
  },
  {
    path: '', component: AdminLayoutComponent,
    children: [      
      { path: 'home', component: IncioComponent },
      { path: 'compania', component: CompaniaComponent },
      { path: 'vehiculo', component: VehiculoComponent },
      { path: 'usuario', component: UsuarioComponent },
      { path: 'zona', component: ZonaComponent },
      { path: 'ruta', component: RutaComponent },
      { path: 'puntovisita', component: PuntoVisitaComponent },
      { path: 'visita', component: VisitaComponent },
      { path: 'calendario', component: CalendarioComponent },
      { path: 'reporteviaje', component: ReporteviajeComponent },
      { path: 'reportepuntovisita', component: ReportePuntoVisitaComponent },
      { path: 'puntovisitalocalizacion', component: ActualizarPuntoVisitaComponent },
      { path: 'reporte-error', component: ReporteErrorComponent },
      { path: 'reporte-facturacion', component: ReporteFacturacionComponent },
      { path: 'viajeForzado', component: CerrarViajeForzadoComponent },
      { path: 'reporteGaleria', component: ReporteGaleriaComponent },
      { path: 'regla', component: ReglasComponent },
      { path: 'reporteViajeContenedor', component: ReporteViajeContenedorComponent },
      { path: 'reportePuntoVisitaDistancia', component: ReportePuntoVisitaDistanciaComponent },
      { path: 'reportePago', component: ReportePagoComponent },
      { path: 'reporteViajeReciboConforme', component: ReporteViajeReciboConformeComponent },
      { path: 'medicion', component: MedicionComponent },
      { path: 'reportePagosEfectuados', component: ReportePagosEfectuadosComponent },
      { path: 'reporteDevolucion', component: ReporteDevolucionesComponent },
      { path: 'reporteMedicionVehiculo', component: ReporteMedicionVehiculoComponent },
      { path: 'motivo', component: MotivoComponent },
      { path: 'correo', component: CorreoComponent },
      { path: 'trasladomerc', component: TrasladoMercaderiaComponent },
      { path: 'importarExcel', component: ImportarExcelComponent },
      { path: 'reporteDevolucionLibre', component: ReporteDevolucionLibreComponent },
      { path: 'reporteIndicadorVisitaCliente', component: IndicadorVisitaClienteComponent },
      { path: 'reporteIndicadorEntregaChofer', component: IndicadorEntregaChoferComponent },
      { path: 'reporteIndicadorFacturaChofer', component: IndicadorFacturasChoferComponent },
      { path: 'reporteIndicadorProporcionEntrega', component: IndicadorProporcionEntregaComponent },
    ],

  },
  { path: '**', redirectTo: '' }
];



@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }

